import { Dispatch, FC, SetStateAction } from 'react';
import useTacticValidationDialog from './TacticValidationDialog.hook';
import {
  dialogStyle,
  titleStyle,
  listIconStyle,
  dialogContentStyle,
  dialogContentBoxStyle,
  loaderWrapperStyle,
} from './TacticValidationDialog.style';
import ActionButton from 'components/ActionButton';
import Box from 'yoda-ui/components/Box';
import CircularProgress from 'yoda-ui/components/CircularProgress';
import Dialog from 'yoda-ui/components/Dialogs/Dialog';
import DialogActions from 'yoda-ui/components/Dialogs/Dialog/DialogActions/DialogActions';
import DialogContent from 'yoda-ui/components/Dialogs/Dialog/DialogContent';
import Icon, { Icons } from 'yoda-ui/components/Icons/Icon';

type TacticValidationDialogTypes = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  cepId?: string;
};

const TacticValidationDialog: FC<TacticValidationDialogTypes> = ({ open, setOpen, title, cepId }) => {
  const {
    notValidGroups,
    dialogConfig,
    removeGroup,
    getTacticsByGroupId,
    loading,
  } = useTacticValidationDialog(setOpen, cepId);
  const { actionsButtonConfig } = dialogConfig;

  return (
    <Dialog open={ open } sx={ dialogStyle }>
      <Box sx={ titleStyle }>{ title }</Box>
      <DialogContent sx={ dialogContentStyle }>
        {
          !loading ? (
            notValidGroups.map((group) => (
              <Box
                key={ group._id }
                sx={ dialogContentBoxStyle }
              >
                <Box>
                  <Box>Parent tactic - { group.title }</Box>
                  <Box>
                    <Icon sx={ listIconStyle } name={ Icons.fiberManualRecordRounded }></Icon>
                    Child tactic - { getTacticsByGroupId(group._id)?.[0]?.title }</Box>
                </Box>

                <ActionButton
                  label={ actionsButtonConfig.removeButtonConfig.label }
                  buttonProps={
                    {
                      onClick: () => removeGroup(group._id),
                      buttonType: actionsButtonConfig.removeButtonConfig.buttonProps.buttonType,
                    }
                  }
                />
              </Box>
            ))
          ) : (
            <Box sx={ loaderWrapperStyle }>
              <CircularProgress/>
            </Box>
          )
        }
      </DialogContent>

      <DialogActions>
        <ActionButton { ...actionsButtonConfig.cancelButtonConfig } />
        <ActionButton { ...actionsButtonConfig.submitButtonConfig }/>
      </DialogActions>
    </Dialog>
  );
};

export default TacticValidationDialog;
